import { DecisionDetail } from "../../../models/home";
import { buildAction, buildConfidence, buildPriority, buildRisk, isoFromNow } from "./home-qa-harness.builders";

export const BLOCKED_DETAIL: DecisionDetail = {
  decision: {
    decisionId: "detail-blocked",
    state: "waiting",
    title: "Process customer reimbursement",
    shortReason: "The recommended action is waiting for the account code confirmation.",
    documents: [
      {
        documentId: "doc-detail-blocked",
        classificationId: "class-detail-blocked",
        title: "Customer reimbursement request"
      }
    ],
    nextBestAction: buildAction("process_reimbursement", "Process reimbursement", true, {
      description: "Issue the reimbursement once the final finance code is present.",
      completionCriteria: ["Confirm customer code", "Validate amount", "Send payment"]
    }),
    availableActions: [
      buildAction("confirm_missing_information", "Go to missing information", true, {
        kind: "remediation",
        placement: "secondary",
        executionMode: "inspect",
        description: "Review the blocking information in this drawer before re-running the business action.",
        completionCriteria: ["Confirm customer code", "Validate amount", "Send payment"]
      }),
      buildAction("process_reimbursement", "Process reimbursement", false, {
        placement: "primary",
        disabledReason: "The billing code is still missing from the source documents.",
        description: "Issue the reimbursement once the final finance code is present.",
        completionCriteria: ["Confirm customer code", "Validate amount", "Send payment"]
      })
    ],
    priority: buildPriority(79, "high", "The SLA expires inside the next two days."),
    risk: buildRisk("medium", "Delay creates customer friction and manual rework."),
    confidence: buildConfidence(0.9),
    evidence: [
      {
        evidenceId: "evidence-blocked-1",
        type: "field",
        label: "Customer id",
        value: "Available",
        confidence: 0.95,
        source: "crm-sync",
        occurredAt: isoFromNow(-5)
      }
    ],
    missingInformation: [
      {
        key: "billing_code",
        label: "Billing code",
        reason: "The billing code is still missing from the source documents.",
        requiredForAction: true,
        severity: "high",
        resolutionLocation: "documentOrigin",
        suggestedUserInput: { type: "text" }
      }
    ],
    owner: { userId: "u-2", displayName: "Customer Ops" },
    dueAt: isoFromNow(32),
    updatedAt: isoFromNow(-2),
    traceId: "detail-blocked-trace",
    sourceTrace: {
      traceId: "detail-blocked-trace",
      actionSource: "policy-engine",
      confidenceSource: "reimbursement-classifier",
      explanationSource: "missing-information-detector",
      evaluatorVersion: "2026.05.10",
      rulesVersion: "home-ia-v3"
    }
  },
  activityPreview: [
    {
      eventId: "activity-blocked-1",
      decisionId: "detail-blocked",
      documentIds: ["doc-detail-blocked"],
      type: "decision.activityAdded",
      title: "Missing information detected",
      narrative: "The decision moved to waiting after the account code could not be verified.",
      occurredAt: isoFromNow(-2)
    }
  ],
  relatedDecisionIds: ["detail-ready"]
};
